export default __webpack_public_path__ + "static/media/calendar-app.980ac4b3.jpeg";